<script>
export default {
  install(Vue) {
    Vue.$videoPlugin = new function() {

      var sources = [
        {
          link: "https://youtube.com/watch?v={0}",
          embed: "https://www.youtube.com/embed/{0}?rel=0",
          patterns: [
            /(?:http(?:s)?:\/\/(?:www\.)?youtu.be\/([a-zA-Z0-9_-]+))/i,
            /(?:http(?:s)?:\/\/(?:www\.)?youtube.com\/watch(?:.+)v=([a-zA-Z0-9_-]+))/i
          ],
          prefix: "youtube:",
        },
        {
          link: "https://vimeo.com/{0}",
          embed: "https://player.vimeo.com/video/{0}?h={1}&color=ffffff&title=0&byline=0&portrait=0",
          patterns: [
            /(?:http(?:s)?:\/\/(?:www\.)?vimeo.com\/([a-zA-Z0-9_-]+\/[a-zA-Z0-9]+))/i
          ],
          prefix: "vimeo_new:",
        },
        {
          link: "https://vimeo.com/{0}",
          embed: "https://player.vimeo.com/video/{0}?color=ffffff&title=0&byline=0&portrait=0",
          patterns: [
            /(?:http(?:s)?:\/\/(?:www\.)?vimeo.com\/([a-zA-Z0-9_-]+))/i
          ],
          prefix: "vimeo:",
        }
      ];

      var getTokenByLinkInPatterns = function (link, patterns) {
        if (link) {
          for (var i = 0; i < patterns.length; i++) {
            var pattern = patterns[i];
            var match = link.match(pattern);
            if (match && match.length > 1) {
              return match[1];
            }
          }
        }
        return null;
      };

      var getTokenByLink = function (link) {
        if (link) {
          for (var i = 0; i < sources.length; i++) {
            var source = sources[i];
            var token = getTokenByLinkInPatterns(link, source.patterns);
            if (token) {
              return source.prefix + token;
            }
          }
        }
        return null;
      };

      var getSourceByToken = function (token) {
        if (token) {
          for (var i = 0; i < sources.length; i++) {
            var source = sources[i];
            if (token.startsWith(source.prefix)) {
              return source;
            }
          }
          return sources[0];
        }
        return null;
      }

      var getLinkByToken = function (token) {
        var source = getSourceByToken(token);
        if (source) {
          token = token.substring(source.prefix.length);
          return source.link.replace("{0}", token);
        }
        return null;
      };

      var getEmbedByToken = function (token) {
        var source = getSourceByToken(token);
        if (source) {
          if (source.prefix === "vimeo_new:") {
            token = token.substring(source.prefix.length);
            const parts = token.split("/");
            const firstPart = parts[0];
            const secondPart = parts[1];
            var embeded = source.embed.replace("{0}", firstPart);
            embeded = embeded.replace("{1}", secondPart);

            return embeded;
          } else {
            token = token.substring(source.prefix.length);
            return source.embed.replace("{0}", token);
          }
        }
        return null;
      };

      return {
        getTokenByLink: getTokenByLink,
        getLinkByToken: getLinkByToken,
        getEmbedByToken: getEmbedByToken
      }
    };
  }
}
</script>
